export default __webpack_public_path__ + "static/media/Chu.2559f1f0.png";